var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4H4.11111H13",
    stroke: "#103045",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85714 2.5C6.69474 2.5 6.53374 2.56752 6.41109 2.6963C6.28765 2.82591 6.21429 3.00669 6.21429 3.2V3.9H9.78571V3.2C9.78571 3.00669 9.71235 2.82591 9.58891 2.6963C9.46626 2.56752 9.30526 2.5 9.14286 2.5H6.85714ZM10.7857 3.9V3.2C10.7857 2.75679 10.6183 2.32712 10.313 2.00664C10.007 1.68534 9.58666 1.5 9.14286 1.5H6.85714C6.41334 1.5 5.99296 1.68534 5.68695 2.00664C5.38174 2.32712 5.21429 2.75679 5.21429 3.2V3.9H4C3.72386 3.9 3.5 4.12386 3.5 4.4V12.8C3.5 13.2432 3.66745 13.6729 3.97267 13.9934C4.27867 14.3147 4.69905 14.5 5.14286 14.5H10.8571C11.3009 14.5 11.7213 14.3147 12.0273 13.9934C12.3325 13.6729 12.5 13.2432 12.5 12.8V4.4C12.5 4.12386 12.2761 3.9 12 3.9H10.7857ZM10.2857 4.9H5.71429H4.5V12.8C4.5 12.9933 4.57336 13.1741 4.6968 13.3037C4.81946 13.4325 4.98045 13.5 5.14286 13.5H10.8571C11.0195 13.5 11.1805 13.4325 11.3032 13.3037C11.4266 13.1741 11.5 12.9933 11.5 12.8V4.9H10.2857ZM9 6.5C9.27614 6.5 9.5 6.72386 9.5 7V11C9.5 11.2761 9.27614 11.5 9 11.5C8.72386 11.5 8.5 11.2761 8.5 11V7C8.5 6.72386 8.72386 6.5 9 6.5ZM7.5 7C7.5 6.72386 7.27614 6.5 7 6.5C6.72386 6.5 6.5 6.72386 6.5 7V11C6.5 11.2761 6.72386 11.5 7 11.5C7.27614 11.5 7.5 11.2761 7.5 11V7Z",
    fill: "#103045",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashGray);
export default __webpack_public_path__ + "static/media/trash-gray.35568822ddde148e289a2cf395d581d9.svg";
export { ForwardRef as ReactComponent };